
import {
  Typography,
  Box,
  Button,
  CircularProgress,
  InputLabel,
  ListItemButton,
} from "@mui/material";
import messageIcon from "../../assets/Icons/message.png";

import emptyIcon from "../../assets/Icons/empty_history.svg";
import Navbar from "./Navbar";
import { useQuery } from "@apollo/client";
import { GET_NOTIFICATION } from "../../Utils/Queries";
import moment from "moment";


const NotificationMobile = () => {

  const { data, loading } = useQuery(GET_NOTIFICATION);


  const sorted =
    data?.getAllNotifications?.items
      ?.slice()
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [];

      if (loading) return <CircularProgress size={10}/>

  return (
    <>
      <Navbar />
      <Box sx={{ p: 2, boxShadow: "border-box", mt: 8 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "#151515", fontSize: "14px", fontWeight: 500 }}
          >
            Notifications
          </Typography>
          <Box>
            <Button
              disabled={!data?.getAllNotifications?.items}
              variant="contained"
              sx={{ fontSize: "10px", borderRadius: 4 }}
            >
              Mark all as read
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 3 }}>
          {!data?.getAllNotifications?.items  ||data?.getAllNotifications?.items?.length === 0 ? (
            <>
              <Box
                sx={{
                  height: "300px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={emptyIcon} alt="empty_img" />
                <Typography
                  sx={{
                    mt: 1,
                    color: "#151515",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  No Notifications
                </Typography>
              </Box>
            </>
          ) : (
            <>
    {sorted?.map((item, idx) => (
                  <ListItemButton
                    sx={{ borderBottom: "1px solid #F2F2F2", py: 1 }}
                    key={idx}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        columnGap: 2,
                        alignItems: "center",

                        width: "100%",
                      }}
                    >
                      <Box sx={{ width: "10%" }}>
                        <img src={messageIcon} alt="icon" width={25} />
                      </Box>
                      <div style={{ flex: 1, width: "85%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            columnGap: 1,
                          }}
                        >
                          <InputLabel
                            sx={{
                              fontSize: "12px",
                              color: "#000",
                              fontWeight: 500,
                            }}
                          >
                            {item?.title}
                          </InputLabel>
                          <Typography
                            sx={{ fontSize: "10px", whiteSpace: "nowrap" }}
                          >
                            {formatWithMoment(item?.createdAt)}
                          </Typography>
                        </Box>
                        <Typography className="two-line-ellipsis">
                          {item?.message}{" "}
                        </Typography>
                      </div>
                    </Box>
                  </ListItemButton>
                ))}

            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default NotificationMobile;

function formatWithMoment(isoString) {
  const time = moment(isoString);
  const now = moment();

  const isToday = time.isSame(now, "day");

  return isToday
    ? `Today at ${time.format("h:mm A")}`
    : time.format("MMM D, YYYY [at] h:mm A");
}

